import { render } from "./DrainMapSuggest.vue?vue&type=template&id=254b0600"
import script from "./DrainMapSuggest.vue?vue&type=script&lang=js"
export * from "./DrainMapSuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__